export default "__VITE_ASSET__QQJQimCc__"